import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const avatarSize = '36px'

const UserListItemTile = ({
   avatarMedia,
   fullName,
   id,
   organization,
   position
}) => {
   const avatarUrl = avatarMedia
      ? avatarMedia?.file.thumbnailUrlW48
      : '/assets/images/avatarPlaceholder.svg'

   return (
      <Link to={`/profile/${id}`}>
         <View
            position="relative"
            width="100%"
            height={avatarSize}>
            <View
               display="block"
               float="left"
               flex="0 0 auto"
               width={avatarSize}
               height={avatarSize}
               borderRadius="50%"
               backgroundColor="#ddd"
               backgroundImage={`url(${avatarUrl})`}
               backgroundSize={avatarMedia ? 'cover' : '30px 30px'}
               backgroundPosition="bottom center"
               style={{
                  backgroundRepeat: 'no-repeat'
               }}
            />
            <View
               display="flex"
               alignItems="flex-start"
               position="absolute"
               top="0px"
               left={avatarSize}
               right="0px"
               bottom="0px"
               paddingLeft="18px">
               <View
                  float="left"
                  width="100%">
                  <Text
                     color="#222"
                     size="2[a-b] 2.5[c-f]"
                     weight="medium"
                     style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                     }}>
                     {fullName}
                  </Text>
                  {(organization || position) && (
                     <Text
                        color="#888"
                        size="1.5"
                        style={{
                           whiteSpace: 'nowrap',
                           overflow: 'hidden',
                           textOverflow: 'ellipsis'
                        }}>
                        <span>{organization}</span>
                        {organization && position && (
                           <span>, </span>
                        )}
                        <span>{position}</span>
                     </Text>
                  )}
               </View>
            </View>
         </View>
      </Link>
   )
}

UserListItemTile.propTypes = {
   avatarMedia: PropTypes.object,
   fullName: PropTypes.string.isRequired,
   id: PropTypes.string.isRequired,
   organization: PropTypes.string,
   position: PropTypes.string
}

UserListItemTile.defaultProps = {
   avatarMedia: undefined,
   organization: undefined,
   position: undefined
}

export default UserListItemTile
